export default __webpack_public_path__ + "static/media/CAPInstructionImage3.fa6bc212.svg";